import React, { useState, useRef, useEffect} from "react";

interface DropdownComponentProps {
    statusColors: Record<string, string>;
    statusList: string[];
    selectedValue: string;
    onChange: (value: string) => void;
    customClass?:string;
    parentClass?:string;
    disabled?:boolean;
}

const StatusDropdown = ({
    statusColors,
    statusList,
    selectedValue,
    onChange,
    customClass="",
    parentClass="",
    disabled=false
}: DropdownComponentProps) => {
    const [isOpen, setIsOpen] = useState(false);
    const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

    const defaultStatusColor = "#ffc61a";
    const dropdownRef = useRef<HTMLDivElement>(null);


    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <div
            ref={dropdownRef}
            className="relative  inline-block text-left"
            onMouseEnter={() => setIsOpen(true)}
            onMouseLeave={() => setIsOpen(false)}
        >
            {/* Button */}
            <button
               
                className={`px-2 ${statusColors[selectedValue]} ${customClass} ${parentClass} py-[5px] capitalize w-[172px] rounded-md  text-white font-medium text-sm focus:outline-none focus:ring-yellow-400`}
            >
                {selectedValue || "Status"}

                {!disabled &&
                <svg
                className={`w-4 h-4 ml-2 inline-block ${isOpen ?"rotate-180":""} ease-in-out duration-500`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                </svg>
                }
            </button>

            {/* Dropdown */}
            {(isOpen && !disabled)&& (
                <ul className={`${customClass} absolute dropdown-menu  w-[172px] mt-2 left-0 right-0  rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-50`}>
                    {statusList.map(
                        (type, index) =>
                            type && (
                                <li key={index}>
                                    <button
                                        onClick={() => {
                                            onChange(type);
                                            setIsOpen(false);
                                        }}
                                        onMouseEnter={() => setHoveredIndex(index)}
                                        onMouseLeave={() => setHoveredIndex(null)}
                                        style={{
                                           
                                            color: hoveredIndex === index ? "white" : "black",
                                            animationDelay: `${index * 0.08}s`,
                                        }}
                                        className={` ${ hoveredIndex === index
                                            ? statusColors[type] || "bg-[#ccc]"
                                            : "bg-transparent"}  dropdown-item capitalize w-full h-[32px] text-left px-4 py-2 text-sm flex justify-between !items-center rounded hover:opacity-90 `}
                                    >
                                        {type}
                                    </button>
                                </li>
                            )
                    )}
                </ul>
            )}
        </div>
    );
};

export default StatusDropdown;
